export const thousandSeprator = (amount) => {
  if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
    return amount.toString().split('.').join('').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  } else {
    return amount;
  }
}

export const unThousandSeprator = (amount) => {
  if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
    return amount.toString().split('.').join('');
  } else {
    return amount;
  }
}

export const unformatNumber = (str) => {
  return parseInt(str.toString().split('.').join(''))
}